import { Table } from 'antd'
import Image from 'next/image'

import { WorkerQrCodeSignatureDisplayBlock as WorkerQrCodeSignatureDisplayBlockType } from '../../types/blueprint'

import { Text } from '@/components/shared-components/BUI/Text'
import { Flexbox } from '@/components/shared-components/Flexbox'
import { TimezonedDate } from '@/context/timezoneContext'

type Props = {
  block: WorkerQrCodeSignatureDisplayBlockType
}

export const WorkerQrCodeSignatureDisplayBlock: React.FC<Props> = ({
  block,
}) => {
  const { workers, competentPersonSignature } = block

  return (
    <Flexbox flexDirection="column" gap="1rem">
      {workers && workers.length > 0 ? (
        <Flexbox flexDirection="column" gap="1rem">
          <Table
            pagination={false}
            columns={[
              {
                title: 'Name',
                dataIndex: 'firstName',
                render: (_text, record) => (
                  <Text>
                    {record.firstName} {record.lastName}
                  </Text>
                ),
              },
              {
                title: 'Signed at',
                dataIndex: 'createdAt',
                render: (text, record) => (
                  <TimezonedDate date={record.createdAt} />
                ),
              },
              {
                title: 'Signature',
                dataIndex: 'signatureUrl',
                render: (text, record) =>
                  record.signedViaQrCode ? (
                    <Text>Signed via QR code</Text>
                  ) : record.signatureUrl ? (
                    <Image
                      src={record.signatureUrl}
                      alt="Signature"
                      width={150}
                      height={50}
                    />
                  ) : (
                    <Text>No signature available</Text>
                  ),
              },
            ]}
            dataSource={[
              ...workers,
              {
                firstName: competentPersonSignature?.signee,
                lastName: '(Competent person)',
                createdAt: competentPersonSignature?.time,
                signatureUrl: competentPersonSignature?.url,
                signedViaQrCode: false,
              },
            ]}
          />
        </Flexbox>
      ) : (
        <Text>No worker acknowledgements recorded</Text>
      )}
    </Flexbox>
  )
}
